module.exports = __webpack_public_path__ + "static/scale-model-of-rhythm-discovery-center-in-indianapolis-indiana-57ad51f1ca3a22902eb1c36d99bcca3f.png";